import yup from 'lib/settings/yup';

export interface InputsFirstStep {
  email: string;
  acceptEmailNotifications: boolean;
}

export const firstStepRegistrationSchema = yup.object({
  email: yup
    .string()
    .email('Digite um e-mail válido.')
    .required('Digite um e-mail válido.'),
  acceptEmailNotifications: yup.boolean().required(),
});
